module.exports = __webpack_public_path__ + "img/am3-optin-promo.db4b0e0.png";